import { Button } from '@shared/components/Button';
import { bounceIn } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface MBSendButtonProps {
  urgent: boolean;
  onClick: () => Promise<void>;
  testID?: string;
}

export function MBSendButton({ urgent, onClick, testID }: MBSendButtonProps) {
  if (urgent) {
    return (
      <Button
        variant="primary"
        size="large"
        icon="send-filled"
        danger
        label={i18n('chat.input.urgent.urgentButtonLabel')}
        onClick={onClick}
        testID={testID}
        className={bounceIn}
      />
    );
  } else {
    return (
      <Button
        variant="primary"
        size="large"
        icon="send-filled"
        iconOnly
        onClick={onClick}
        testID={testID}
        className={bounceIn}
      />
    );
  }
}
